const arrayToKeyValueObj = (array, valueFn = (v) => v) => {
    return array
        .map(v => [v, valueFn(v)])
        .reduce(
            (accObj, [ key, value ]) => ({
                ...accObj,
                [key]: value
            })    
        , {})
}

const camelCaseToDash = (str) => str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()

export {
    arrayToKeyValueObj,
    camelCaseToDash
}